import React, { useState, useEffect, useCallback } from "react";
import { getQuizParticipationListApi } from "../../../services/QuizService";
import DebounceSearchInput from "../../constant/DebounceSearchInput";
import TableLoaderEffect from "../../constant/TableLoader";
import Pagination from "../../constant/Pagination";
import { CancelRequest } from "../../../services/AxiosInstance";
const AdminQuizParticipation = ({ quizId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    query: "",
  });
  const recordsPage = 25;

  const fetchData = useCallback(() => {
    CancelRequest();
    setIsLoading(true);
    getQuizParticipationListApi(quizId, currentPage, recordsPage, filter)
      .then((resp) => {
        setData(resp.data.results);
        setTotal(resp.data.total);
      })
      .catch((error) => {
        console.error(error.response?.data?.message || "Error fetching data");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage, filter]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePagination = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setFilter((prev) => ({
      ...prev,
      query: value,
    }));
    setCurrentPage(1);
  };

  return (
    <div className="card-body p-0">
      <div className="table-header">
        <h3 className="mb-0">Participant List</h3>
        <div className="table-left-header">
          <div className="form-group me-3">
            <DebounceSearchInput handleSearchChange={handleSearchChange} />
          </div>
        </div>
      </div>
      <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
        <table
          id="employees-tblwrapper"
          className="table ItemsCheckboxSec dataTable no-footer mb-0"
        >
          <thead>
            <tr>
              <th>Participant</th>
              <th>Score</th>
              <th>Incorrect</th>
              <th>Total Attend</th>
              <th>Feedback</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <TableLoaderEffect colLength={6} />
            ) : data && data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item.id || index}>
                  <td>
                    <span className="text-primary fw-bold c-pointer">
                      {item?.user.name}
                    </span>
                    <br />
                    <small>{item?.user.email}</small>
                  </td>
                  <td>{item.score}</td>
                  <td>{item.no_of_incorrect}</td>
                  <td>{item.no_question_attend}</td>
                  <td>
                    <span className="text-wrap">
                    {item.feedback || ""}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isLoading ? (
        <div style={{ height: "4rem" }}></div>
      ) : (
        <Pagination
          currentPage={currentPage}
          recordsPage={recordsPage}
          dataLength={total}
          handlePagination={handlePagination}
        />
      )}
    </div>
  );
};

export default AdminQuizParticipation;
